class Search {
    static init() {
        $().ready(() => {
            $('#manufacturerSelect').select2({
                allowClear: true,
                placeholder: 'Choose manufacturers...',
                width: 'style'
            });
            $('#manufacturerSelect').on('change', () => {
                $('#manufacturersForm').submit();
                $('#manufacturerSelect').prop("disabled", true);
            });
            $('#contractSelect').select2({
                allowClear: true,
                placeholder: 'Choose contracts...',
                width: 'style'
            });
            $('#contractSelect').on('change', () => {
                $('#contractsForm').submit();
                $('#contractSelect').prop("disabled", true);
            });
            $('#regionalContractSelect').select2({
                allowClear: true,
                placeholder: 'Choose contracts...',
                width: 'style'
            });
            $('#regionalContractSelect').on('change', () => {
                $('#regionalContractsForm').submit();
                $('#regionalContractSelect').prop("disabled", true);
            });
            //NAICS
            $('#naics-select').select2({
                allowClear: true,
                placeholder: 'Choose NAICS code...',
                minimumInputLength: '2',
                width: 'style',
                ajax: {
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return { searchString: params.term };
                    },
                    processResults: function (data) {
                        return { results: data };
                    },
                    url: '/Search/GetNAICSCodes'
                }
            });
            $('#naics-select').on('change', (e) => {
                $('#naicsCodesForm').submit();
                $('#naicsCodeSelect').prop("disabled", true);
            });
            //SIN
            $('#sin-select').select2({
                allowClear: true,
                placeholder: 'Choose SIN code...',
                minimumInputLength: '2',
                width: 'style',
                ajax: {
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return { searchString: params.term };
                    },
                    processResults: function (data) {
                        return { results: data };
                    },
                    url: '/Search/GetSINCodes'
                }
            });
            $('#sin-select').on('change', (e) => {
                $('#sinCodesForm').submit();
                $('#sinCodeSelect').prop("disabled", true);
            });
            //PSC
            $('#psc-select').select2({
                allowClear: true,
                placeholder: 'Choose PSC code...',
                minimumInputLength: '2',
                width: 'style',
                ajax: {
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return { searchString: params.term };
                    },
                    processResults: function (data) {
                        return { results: data };
                    },
                    url: '/Search/GetPSCCodes'
                }
            });
            $('#psc-select').on('change', (e) => {
                $('#pscCodesForm').submit();
                $('#pscCodeSelect').prop("disabled", true);
            });
        });
    }

    static handleShippingLocationSelected(element) {
        var index = element.selectedIndex;

        document.getElementById('p-shipToFacilityId').value = element[index].value;
        document.getElementById('p-shipToFacilityName').value = element[index].text;
    }
}

export default Search;